import React from "react";
import { Label } from "./Label";

export function Field({
  label,
  id,
  help,
  children,
}: {
  label: string;
  id: string;
  help?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-sm font-medium text-primary">
        {label}
      </Label>
      {children}
      {help ? <p className="text-xs text-secondary">{help}</p> : null}
    </div>
  );
}

export function SectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="pt-2 text-lg font-semibold text-primary">{children}</h2>
  );
}
